/**
 * Canônico de telefone do ecossistema comercial Orbion: SEMPRE "55" (DDI Brasil)
 * + DDD + número. Tira não-dígitos e zeros à esquerda; número nacional (10-11
 * dígitos) recebe o "55" na frente; número que já tem DDI (12-13 dígitos) é mantido;
 * vazio continua vazio. Idempotente.
 *
 * É o MESMO formato do dashboard (date-utils normalizePhone) e das tabelas ghl_ e bd_.
 * Toda escrita e busca de telefone no desk deve passar por aqui, para garantir um
 * único formato em todas as plataformas.
 */
export function normalizePhone(phone) {
  const d = String(phone ?? '').replace(/\D/g, '').replace(/^0+/, '');
  if (!d) return '';
  if (d.length === 10 || d.length === 11) return '55' + d;
  return d;
}
